import { AuthenticationResponse } from "services/organizationPortalClient";
import authStore, { AuthStore } from "stores/authStore";
import { ClaimType, UserClaim } from "types/claimTypes";
import { OrganizationContextStorage } from "utils/organizationContextStorage";

export const buildAuthentication = (
  authenticationResponse: AuthenticationResponse
) => {
  createUserClaim(authenticationResponse);

  const userRaw = global.localStorage.getItem("user");
  const userData = JSON.parse(userRaw!) as AuthStore;

  authStore.update((s) => {
    s.isLoggedIn = true;
    s.firstName = userData.firstName;
    s.lastName = userData.lastName;
    s.impersonatedUserEmail = userData.impersonatedUserEmail;
    s.claims = userData.claims;
    s.id = userData.id;
  });
};

export const clearAuthentication = () => {
  authStore.update((s) => {
    s.isLoggedIn = false;
    s.firstName = null;
    s.lastName = null;
    s.email = null;
    s.impersonatedUserEmail = null;
    s.id = null;
  });

  global.localStorage.clear();
  OrganizationContextStorage.clear();
};

export const hasUserPermission = (
  parentClaim: string,
  claimResource: string,
  claimPermission: string
) => {
  const userRaw = global.localStorage.getItem("user");
  if (!userRaw) {
    return false;
  }

  const userData = JSON.parse(userRaw) as AuthStore;
  if (!userData) {
    return false;
  }

  return userData.claims?.some(
    (c) =>
      c?.claimType === ClaimType.Permission &&
      c?.parentClaim === parentClaim &&
      c?.claimResource === claimResource &&
      c?.claimPermission === claimPermission
  );
};

const createUserClaim = (userResponse: AuthenticationResponse) => {
  const claims = userResponse.permissions?.map((perm: string) => {
    try {
      const splitted = perm.split(".");

      return {
        claimType: ClaimType.Permission,
        parentClaim: splitted[0],
        claimResource: splitted[1],
        claimPermission: splitted[2],
      } as UserClaim;
    } catch {
      console.log("There are permissions not properly processed.");
      // eslint-disable-next-line array-callback-return
      return;
    }
  });

  const userAuthStore: AuthStore = {
    id: userResponse.id ?? null,
    email: userResponse.email,
    firstName: userResponse.firstName,
    lastName: userResponse.lastName,
    isLoggedIn: true,
    impersonatedUserEmail: userResponse.impersonatedUserEmail,
    claims: claims ?? [],
  };

  global.localStorage.setItem("user", JSON.stringify(userAuthStore));

  authStore.update((s) => {
    s.id = userAuthStore.id;
    s.email = userAuthStore.email;
    s.isLoggedIn = true;
    s.firstName = userAuthStore.firstName;
    s.lastName = userAuthStore.lastName;
    s.impersonatedUserEmail = userAuthStore.impersonatedUserEmail;
    s.claims = userAuthStore.claims;
  });
};
